<!-- 服务项目信息编辑页 -->
<template>
  <div class="edit white">
    <el-dialog :title="addEditTitle" :visible.sync="addEditShow" width="700px" :before-close="handleChangeDrawer" :close-on-click-modal="false">
        <div class="pay-mains">
          <el-form ref="form" :model="form" class="demo-ruleForm" label-width="160px" label-position="left">
            <el-row>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="urgentContactName"
                  label="紧急联系人姓名："
                  prop="urgentContactName"
                >
                  <div class="flex-row">
                    <el-input v-model="form.urgentContactName" placeholder="请输入" maxlength="10"></el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="urgentContactMobile"
                  label="手机号码："
                  prop="urgentContactMobile"
                >
                <el-input v-model="form.urgentContactMobile" placeholder="请输入" maxlength="11"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="relationWithMe"
                  label="与本人关系："
                  prop="relationWithMe"
                >
                  <el-input v-model="form.relationWithMe" placeholder="请输入" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="btns">
            <el-button type="primary" @click="save">确定</el-button>
          </div>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
  data() {
    return {
      addEditShow: false,
      addEditTitle: "",
      form: {
        urgentContactName: "", 
        urgentContactMobile: "",
        relationWithMe: "",
      },
      oldForm: {},
      userInfo: {
        shopBizConfig: {

        }
      },
    };
  },
  mixins: [minxin],
  created() {},
  methods: {
    //  页面初始化函数
    init (item) {
      this.userInfo = this.$store.getters.ShopInfo;
      console.log(this.userInfo);
      if (item) {
        this.oldForm = item;
        // this.form = item;
        this.form = JSON.parse(JSON.stringify(item));
      } else {
        this.form = {
          urgentContactName: "", 
          urgentContactMobile: "",
          relationWithMe: "",
        }
      }
      this.addEditShow = true;
      this.addEditTitle = "紧急联系人";
    },
    handleChangeDrawer(val) {
      // this.$refs["form"].clearValidate();
      this.addEditShow = false;
    },
    // 保存
    save () {
      if (this.userInfo.shopBizConfig.yuanyuanFlag && this.userInfo.manageModel == "group") {
        if (!this.form.urgentContactName) {
          return this.$message.error("请输入紧急联系人姓名");
        } else if (!this.form.urgentContactMobile) {
          return this.$message.error("请输入手机号码");
        } else if (!this.form.relationWithMe) {
          return this.$message.error("请输入与本人关系");
        }
      } else if (!this.userInfo.shopBizConfig.yuanyuanFlag) {
        if (this.form.urgentContactName && (!this.form.urgentContactMobile || !this.form.relationWithMe)) {
          return this.$message.error("请输入手机号码和本人关系");
        } else if (this.form.urgentContactMobile && (!this.form.urgentContactName || !this.form.relationWithMe)) {
          return this.$message.error("请输入紧急联系人姓名和本人关系");
        } else if (this.form.relationWithMe && (!this.form.urgentContactName || !this.form.urgentContactMobile)) {
          return this.$message.error("请输入紧急联系人姓名和手机号码");
        } else if (this.form.urgentContactMobile && this.form.urgentContactMobile.length != 11) {
          return this.$message.error("请输入手机号码");
        }
      }
      this.addEditShow = false;
      this.$emit("change", this.form);
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  padding: 0;
  height: 100%;
  /deep/ .el-form-item__content {
      width: 250px !important;
  }
  /deep/ .el-input__suffix {
    right: 10px;
  }
  .elButton {
    height: 30px;
  }
  /deep/ .el-form {
    padding-bottom: 20px;
    /deep/ .el-form-item {
      background: #fff;
    //   border-bottom: 1px solid @borderColor;
      padding: 10px 0;
      // margin-bottom: 0;
      &:last-child {
        border-bottom: 0;
      }
      
    }
    
  }
}
</style>